import { indexResources } from '@esentai/core/ducks/dao/actions';
import findByIdStart from '@esentai/core/ducks/dao/reducers/byId/findByIdStart';
import findByIdSuccess from '@esentai/core/ducks/dao/reducers/byId/findByIdSuccess';
import createTaskSaga from '@esentai/core/ducks/tasks/createSaga';
import {
  createStoreBonus,
  fetchStoreBonus,
} from '@esentai/core/features/storeBonuses/sagas';
import { push } from 'connected-react-router';
import { call, put, select, takeEvery } from 'redux-saga/effects';

import { getStoreBonusId } from './selectors';
import {
  CREATE_DRAFT,
  FETCH_ITEM,
  GO_TO_STEP_ONE,
  GO_TO_STEP_TWO,
  SUBMIT,
} from './types';
import { createFormStepURL, generateRandomId } from './utils';

export function* goToStep(step) {
  const id = yield select(getStoreBonusId);
  const url = yield call(createFormStepURL, id, step);

  yield put(push(url));
}

export function* createDraft(action) {
  const { payload: attributes } = action;
  const id = generateRandomId();

  localStorage.setItem(`store-bonus-${id}`, JSON.stringify(attributes));
  const url = yield call(createFormStepURL, id, 2);

  yield put(push(url));
}

export function* fetchItem(action) {
  const { payload: id } = action;

  if (Number.isInteger(id)) {
    yield call(fetchStoreBonus, id);
  } else {
    const payload = JSON.parse(localStorage.getItem(`store-bonus-${id}`));

    yield put(findByIdStart(id));
    yield put(indexResources(payload));
    yield put(findByIdSuccess(id));
  }
}

export function* goToStepOne() {
  yield call(goToStep, 1);
}

export function* goToStepTwo(action) {
  const { payload: attributes } = action;
  const id = yield select(getStoreBonusId);

  localStorage.setItem(`store-bonus-${id}`, JSON.stringify(attributes));
  yield call(goToStep, 2);
}

export function* submitStoreBonus(action) {
  const { payload: attributes } = action;
  const id = yield select(getStoreBonusId);

  const cached = `store-bonus-${id}`;
  const firstStepAttrs = JSON.parse(localStorage.getItem(cached));

  yield call(createStoreBonus, { ...attributes, ...firstStepAttrs });
  delete localStorage[cached];
}

export default function*() {
  yield takeEvery(CREATE_DRAFT, createTaskSaga(createDraft));
  yield takeEvery(FETCH_ITEM, createTaskSaga(fetchItem));
  yield takeEvery(GO_TO_STEP_ONE, createTaskSaga(goToStepOne));
  yield takeEvery(GO_TO_STEP_TWO, createTaskSaga(goToStepTwo));
  yield takeEvery(SUBMIT, createTaskSaga(submitStoreBonus));
}
